document.addEventListener('bless', (e) => {
	const copyTextButtons = e.target.querySelectorAll('[data-copy-text]');

	copyTextButtons.forEach((button) => {
		button.addEventListener('click', () => {
			const textToCopy = button.dataset.copyText;

			if (!textToCopy) {
				return;
			}

			navigator.clipboard.writeText(textToCopy).then(
				() => {
					button.classList.add('copied');
					setTimeout(() => button.classList.remove('copied'), 2000);
				},
				(err) => {
					console.error('Could not copy text: ', err);
				}
			);
		});
	});
});
